const PHRASES = [
  "Mitochondrial Energy",
  "Frictionless Performance",
  "Somatic Mastery",
  "Burnout Is A Engineering Failure",
  "Cellular Voltage",
  "Biological Autonomy",
  "Peak Flow States",
  "Executive Longevity",
];

function Row() {
  return (
    <div className="flex items-center shrink-0">
      {PHRASES.map((p, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-serif italic text-lg sm:text-2xl lg:text-3xl text-gold/70 tracking-wide whitespace-nowrap px-6 sm:px-10">
            {p}
          </span>
          <span className="w-1.5 h-1.5 rotate-45 bg-copper/70 shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      className="relative border-y border-gold/15 bg-ink-2/60 py-5 sm:py-7 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
